export default __webpack_public_path__ + "static/media/N116EP-Outside.8b126696.png";